import styled from "@emotion/styled"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import quoteClose from "../images/quote-close-blue.svg"
import quoteOpen from "../images/quote-open-blue.svg"
import RichText from "./RichText"

const StyledBlockquote = styled.blockquote`
  ${tw`leading-loose italic text-gray text-lg`}
  ${(props) =>
    props.alignText === `center` ? tw`text-center lg:mx-auto lg:w-3/4` : null}
`
const Quote = styled.div`
  p:first-of-type::before,
  p:last-of-type::after {
    width: 24px;
    height: 18px;
    display: inline-block;
    vertical-align: middle;
  }
  p:first-of-type::before {
    content: url(${quoteOpen});
    margin-right: 0.5em;
    transform: translateY(-50%);
  }
  p:last-of-type::after {
    content: url(${quoteClose});
    margin-left: 0.5em;
    margin-right: -40px;
    transform: translateY(0%);
  }
`
const Attribution = styled.footer`
  cite {
    ${tw`not-italic text-base`}
  }
  &::before {
    ${tw`block border-t border-teal w-4 my-2`}
    ${(props) =>
      props.alignText === `center` ? tw`mx-auto` : null}
    content: ' ';
  }
`
const Blockquote = ({ block }) => {
  const text = get(block, "elements.text.value")
  const attribution = get(block, "elements.attribution.value")
  const alignText = get(block, "elements.align_text.value[0].codename")

  return (
    <StyledBlockquote alignText={alignText}>
      <Quote>
        <RichText styled={false}>{text}</RichText>
      </Quote>
      {attribution ? (
        <Attribution alignText={alignText}>
          <cite>{attribution}</cite>
        </Attribution>
      ) : null}
    </StyledBlockquote>
  )
}

export default Blockquote
